import { Banners, UserId } from '@raysee/domain';
import { BannerSlotEnum } from '@raysee/schema';
import { BannerState, TopPageBannersState } from '../state/bannerState';
import { BannerUsecase } from '../usecase/bannerUsecase';

export class TopPageBannerPresenter {
  private toBannerState = (banners: Banners, slotName: BannerSlotEnum): BannerState[] =>
    banners.values
      .filter((banner) => banner.bannerSlot.value === slotName)
      .map((banner) => ({
        bannerId: banner.id.value,
        name: banner.name.value,
        imageUrl: banner.imageUrl.value,
        linkUrl: banner.linkUrl.value,
        isGuestLimited: banner.isGuestLimited.value,
      }));

  private toTopPageBannerState = (banners: Banners): TopPageBannersState => ({
    topPagePhoneRectangleBanners: this.toBannerState(banners, BannerSlotEnum.HomeTopPhoneRectangle),
    topPageChatRectangleBanners: this.toBannerState(banners, BannerSlotEnum.HomeTopChatRectangle),
    topPageMiddleBanners: this.toBannerState(banners, BannerSlotEnum.HomeTopBanner),
    topPageFooterBanners: this.toBannerState(banners, BannerSlotEnum.HomeFooterBanner),
  });

  getTopPageBannersForGuest = async (): Promise<TopPageBannersState> => {
    const bannerUsecase = new BannerUsecase();
    const banners = await bannerUsecase.getTopPageBannersForGuest();
    return this.toTopPageBannerState(banners);
  };

  getTopPageBannersForAuthUser = async (userId: string): Promise<TopPageBannersState> => {
    const bannerUsecase = new BannerUsecase();
    const banners = await bannerUsecase.getTopPageBannersForAuthUser(new UserId(userId));
    return this.toTopPageBannerState(banners);
  };
}
